import React, { Component } from 'react';


class Footer extends Component{
  render(){
    return(
      <footer>
        &copy; 2017 GigZap inc.
      </footer>
    );
  }
}


export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js